module.exports = __webpack_public_path__ + "static/img/concept_rent_friend.3749c93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/concept_rent_friend.jpg
// module id = 285
// module chunks = 0